<template>
    <button @click="clicked" :disabled :class="{ 'disabled': disabled }">
        <div v-if="!loading" class="flex items-center gap-1 justify-center">
            <i v-if="icon" :class="icon" />
            <img v-else-if="img" :src="img" class="w-4 h-4 inline" />
            {{ text }}
        </div>
        <div v-if="loading === true" class="flex items-center justify-center">
            <div class="loader" />
        </div>
    </button>
</template>

<script>
export default {
  name: "bouton-action",
};
</script>
<script setup>
const props = defineProps({
  text: String,
  icon: String,
  img: String,
  loading: Boolean,
  disabled: {
    type: Boolean,
    default: false,
  }
});
const emit = defineEmits(["click"]);

function clicked() {
  emit("click");
}
</script>

<style scoped>
.loader {
    border: 2px solid #f3f3f3; /* Light grey */
    border-top: 2px solid #6492c6; /* Blue */
    border-radius: 50%;
    width: 20px;
    height: 20px;
    margin: 0 20px;
    animation: spin 2s linear infinite;
}

@keyframes spin {
    0% {
        transform: rotate(0deg);
    }
    100% {
        transform: rotate(360deg);
    }
}
</style>
